import React from 'react';
import { UnifiedSessionRecording } from '@/components/recording/UnifiedSessionRecording';

interface RecordingTabProps {
  booking: {
    id: string;
    client_id: string;
    practitioner_id: string;
    start_time: string;
    end_time: string;
    status: string;
    format: string;
    clients?: {
      first_name: string;
      last_name: string;
    };
    practitioners?: {
      first_name: string;
      last_name: string;
    };
  };
}

export function RecordingTab({ booking }: RecordingTabProps) {
  return (
    <div className="space-y-4 pb-4 px-2 sm:px-0">
      <div className="rounded-lg border bg-card p-3 sm:p-4">
        <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Session Recording</h3>
        <UnifiedSessionRecording 
          bookingId={booking.id}
          practitionerId={booking.practitioner_id}
          clientId={booking.client_id}
        />
      </div>
    </div>
  );
}